import { environment } from '../../environments/environment';
import type { CompanySearchApiResult } from './fetchCompanySearchResults';

/**
 * Look up a single company by rcid via the company-mapper's exact `/get-company`
 * endpoint. Unlike `/search` (fuzzy tfidf name matching, where a numeric query
 * is an unreliable rcid lookup), this is the authoritative by-rcid endpoint —
 * its `primary_identifiers` reliably carry the RICS ancestry (rics_k10/k400)
 * needed to place a company in the tree. Returns a single record (not an array).
 */
export const fetchCompanyByRcid = async (
  rcid: number,
  signal?: AbortSignal
): Promise<CompanySearchApiResult | null> => {
  const response = await fetch(
    `${environment.COMPANY_MAPPER_URL}/get-company`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ rcid }),
      signal,
    }
  );

  if (!response.ok) {
    throw new Error(`get-company failed: ${response.status}`);
  }

  return response.json();
};
